import apiClient from './api-client';
import { getStoredUser } from './session';

const changeOwnership = endpoint => formData => apiClient.post(endpoint, formData);

export const getContractAmount = () => apiClient.get('contractAmount');

export const getContracts = () =>
  apiClient.post('getContracts', {
    email: getStoredUser()?.data?.user?.email,
    limit: 100,
    skip: 0,
  });

export const getContractDetail = id =>
  apiClient.get(`getTransactionDetail/${id}`);

export const approveContractOtp = () => apiClient.post('approve-contract-otp', '');

export const getContractList = () => apiClient.get('getContractList');

export const changeMarketPlaceOwnerShip = changeOwnership('changeMarketPlaceOwnerShip');
export const mainContractChangeOwnerShip = changeOwnership('mainContractChangeOwnerShip');
export const escrowContractChangeOwnerShip = changeOwnership('escrowContractChangeOwnerShip');
export const changeTrackingContractOwnerShip = changeOwnership('changeTrackingContractOwnerShip');
export const changeVotingContractOwnerShip = changeOwnership('changeVotingContractOwnerShip');
